import LockSimulator from './LockSimulator.vue'

export default LockSimulator
